import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export default {
  state: { 
    user: null,
    endpoints: {
      updateUserPassword: 'https://stormy-mountain-29119.herokuapp.com/v3/update_user_password/',
    },
  },
  mutations,
  actions,
  getters,
}